import { ElegantExcludedProductIds } from './elegantExcludedProductIds';

export const ProductionCCMProductIds = [
	ElegantExcludedProductIds.ProductionCCMId1,
	ElegantExcludedProductIds.ProductionCCMExternalId1,
	ElegantExcludedProductIds.ProductionCCMExternalServicesId1,
	ElegantExcludedProductIds.ProductionCCMId2,
	ElegantExcludedProductIds.ProductionCCMExternalId2,
	ElegantExcludedProductIds.ProductionCCMExternalServicesId2,
	ElegantExcludedProductIds.ProductionCCMId3,
	ElegantExcludedProductIds.ProductionCCMExternalId3,
	ElegantExcludedProductIds.ProductionCCMExternalServicesId3,
	ElegantExcludedProductIds.ProductionCCMId4,
	ElegantExcludedProductIds.ProductionCCMExternalId4,
	ElegantExcludedProductIds.ProductionCCMExternalServicesId4
] as const;
